// extracted by mini-css-extract-plugin
module.exports = {"component":"repeater-matrix-type-double_component_LhSEi","column":"repeater-matrix-type-double_column_12FMr"};